import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const steps = [
  { title: 'Attract', desc: 'Reach the right audience through SEO, Google Ads, social media, content, and email.', icon: 'FiCrosshair' },
  { title: 'Convert', desc: 'Turn attention into action with better websites, landing pages, forms, and follow-up.', icon: 'FiZap' },
  { title: 'Manage', desc: 'Organize opportunities through CRM systems, custom software, and automated workflows.', icon: 'FiLayers' },
  { title: 'Improve', desc: 'Measure what happens, identify what is not working, and improve the customer journey.', icon: 'FiActivity' }
];

const ConnectedGrowth = () => {
  return (
    <section className="section-padding relative overflow-hidden bg-gray-950">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=2000&auto=format&fit=crop')] bg-cover bg-fixed opacity-5 mix-blend-screen"></div>

      <div className="container-custom relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-50px" }}
          >
            <span className="text-purple-400 font-medium tracking-widest text-sm uppercase mb-4 block font-display">
              More Than A List Of Services
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold mb-8 text-white">
              We Build <span className="text-gradient-alt">Connected Growth Systems.</span>
            </h2>
            
            <div className="space-y-6 text-gray-400 text-lg font-light">
              <p>A website by itself is not a strategy.</p>
              <p>SEO without strong landing pages will only take you so far. Advertising without proper tracking wastes money. A CRM without a defined process becomes another unused tool. Leads generated after hours are still lost if no one answers the phone.</p>
              
              <div className="p-6 rounded-2xl glass-panel border-purple-500/30 mt-8">
                <p className="font-display font-bold text-white text-xl">
                  LAJ Digital connects these pieces into one system.
                </p>
              </div>
            </div>
          </motion.div>

          <div className="relative">
            {/* Connecting Line */}
            <div className="absolute left-[27px] top-10 bottom-10 w-[2px] bg-gradient-to-b from-cyan-500 via-purple-500 to-cyan-500 opacity-30 hidden sm:block"></div>
            
            <div className="space-y-6">
              {steps.map((step, idx) => (
                <motion.div 
                  key={step.title}
                  initial={{ opacity: 0, x: 30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ delay: idx * 0.15 }}
                  className="flex gap-6 relative"
                >
                  <div className="w-14 h-14 rounded-full bg-gray-900 border-2 border-gray-700 flex items-center justify-center flex-shrink-0 relative z-10 shadow-[0_0_15px_rgba(0,0,0,0.5)]">
                    <SafeIcon icon={step.icon} className="text-xl text-white" />
                  </div>
                  <div className="glass-card rounded-2xl p-6 flex-grow">
                    <h3 className="text-xl font-display font-bold mb-2 text-white">{step.title}</h3>
                    <p className="text-gray-400 text-sm leading-relaxed">{step.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ConnectedGrowth;